"use client";

import React from "react";

import { getIconBySlug } from "@/utils/icon-mapping";

interface ThemeClickableCardProps {
  club: any;
  href: string;
}

export default function ThemeClickableCard({ club }: ThemeClickableCardProps) {
  const ThemeIcon = getIconBySlug(club?.theme?.icon?.slug);

  if (!club.theme) {
    return null;
  }

  return (
    // <Link href={href} className="block h-full">
    <div className="bg-yellow rounded shadow-md flex flex-col items-center justify-center h-full p-4 text-center hover:bg-yellow-400 transition-colors">
      <ThemeIcon
        className="mb-1 text-neutral-900"
        style={{ fontSize: "45px" }}
      />
      <span className="text-sm font-bold text-neutral-900">THÈME</span>
      <span className="font-bold text-neutral-900">{club.theme.name}</span>
    </div>
    // </Link>
  );
}
